import { Drawer, Box, Typography } from '@mui/material';
import { MenuContent } from './MenuContent';
import { designTokens } from '../../theme/design-tokens';

const DRAWER_WIDTH = designTokens.spacing['sidebar-width'];

const colors = {
  surfaceContainerLowest: '#ffffff',
  surfaceContainerLow: '#eff4ff',
  outlineVariant: '#c3c5d9',
  primary: '#003ec7',
  onPrimary: '#ffffff',
  onSurface: '#0b1c30',
  outline: '#737688',
};

export interface SideMenuProps {
  onLogout: () => void;
}

/**
 * Side Menu Component (Desktop)
 *
 * Permanent drawer for desktop navigation.
 * Design aligned with Stitch: Nexus Admin design system.
 *
 * Features:
 * - 260px width, white background, 1px right-border
 * - Brand logo and role selector
 * - Navigation with active state (blue left bar + background)
 * - User profile at bottom
 */
export function SideMenu({ onLogout }: SideMenuProps) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          backgroundColor: colors.surfaceContainerLowest,
          borderRight: `1px solid ${colors.outlineVariant}`,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          py: 3,
          px: 2,
        }}
      >
        {/* Logo / Brand Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, mb: 3 }}>
          <Box
            component="img"
            src="/assets/logo.png"
            alt="StyleConnect"
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              objectFit: 'contain',
            }}
          />
          <Box>
            <Typography
              sx={{
                fontSize: '18px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                color: colors.onSurface,
                lineHeight: '24px',
              }}
            >
              StyleConnect
            </Typography>
          </Box>
        </Box>
        <MenuContent onLogout={onLogout} />
      </Box>
    </Drawer>
  );
}
